import type { EcosystemAddresses } from '@polaris/core/services'
import {
  type GetRouteRequest,
  type GetRouteResponse,
  getRoute,
} from '@polaris/core/services'
import {
  queryOptions,
  type UndefinedInitialDataOptions,
} from '@tanstack/react-query'

export const getRouteQuery = (
  searchParams: GetRouteRequest,
  ecosystemToAddr:
    | {
        ecosystemToAddrMain: EcosystemAddresses
        ecosystemToAddrFinalDest: EcosystemAddresses
      }
    | undefined,
  options?: Partial<
    UndefinedInitialDataOptions<
      GetRouteResponse,
      Error,
      GetRouteResponse,
      (string | GetRouteRequest)[]
    >
  >,
) =>
  queryOptions({
    queryKey: ['routes', searchParams, JSON.stringify(ecosystemToAddr)],
    queryFn: ({ signal }) => getRoute(searchParams, ecosystemToAddr, signal),
    ...options,
  })
